import { useState } from "react";
import { defaultLinjeKursusholdColumns } from "../../../../../config/linjeConfig";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import IngenRegistreringer from "../../../person/id/IngenRegistreringer";
import OpretNyButtonBlock from "../../../person/id/OpretNyButtonBlock";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import { Fmulinje } from "../../../../../interfaces/schema";
import { SortBy } from "../../../../../interfaces/table";
import { orderBy } from "../../../../../util/orderBy";

const defaultSortBy: SortBy<any>[] = [
  {
    direction: "asc",
    field: "fraDato",
  },
];

export default function LinjeKurser(props: { fmulinje: Fmulinje }) {
  const [linjeKursusholdColumns, setLinjeKursusholdActiveColumns] =
    useActiveColumns(
      "linje-linjekursushold-active-columns",
      defaultLinjeKursusholdColumns,
    );

  const { fmulinje } = props;
  const { kursushold } = fmulinje;
  const [sortBy, setSortBy] = useState<SortBy[]>(defaultSortBy);

  if ((kursushold as unknown as []).length === 0) {
    return <IngenRegistreringer />;
  }
  return (
    <ModalProvider>
      <TableRoot>
        <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
          <>
            {getHeaderActiveColumns(linjeKursusholdColumns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </>
        </TableHead>
        <TableBody>
          {orderBy(
            kursushold,
            sortBy.map((s) => s.field),
            sortBy.map((s) => s.direction),
          ).map((hold, i) => {
            return (
              <TableRow key={i}>
                <>
                  {linjeKursusholdColumns
                    .filter((col) => col.active)
                    .map((col) => {
                      return <TD key={col.field} col={col} rowData={hold} />;
                    })}
                </>
              </TableRow>
            );
          })}
        </TableBody>
      </TableRoot>
      <ColumnEditorModal
        defaultColumns={defaultLinjeKursusholdColumns}
        columns={linjeKursusholdColumns}
        setActiveColumns={setLinjeKursusholdActiveColumns}
      />
      <OpretNyButtonBlock />
    </ModalProvider>
  );
}
